<template>
  <div class="row">
    <div class="col-md-12">
      <printer-form :route="route"></printer-form>
    </div>
  </div>
</template>
<script>
  import PrinterForm from 'src/components/Dashboard/Views/Settings/Printer/PrinterForm.vue'
  export default {
    components: {
      PrinterForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Printer/PrinterAdd.vue